<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-nav-bar
        title="绑定学籍"
        left-text="返回"
        left-arrow
        fixed
        class="fixedapp"
        @click-left="goBack('/')"
      />
      <div class="form-info" style="padding-top:4rem;">
        <van-form @submit="onSubmit" @failed="onFailed" ref="form">
          <van-cell-group title="查询并绑定学籍信息">
            <van-field
              v-model="form.sfzh"
              name="sfzh"
              label="身份证号"
              placeholder="身份证号"
              clearable
              :rules="[{ required: false, validator: (value, rule) => {
                  if (value) {
                    let m = value.match(/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/); 
                    return m ? true : false;
                  }
                  return true
                }, 
                //pattern:/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
                message: '请填写正确的身份证号' }]"
            />
            <van-divider :style="{color: '#1989fa'}">OR</van-divider>
            <van-field
              type="number"
              v-model="form.mobile"
              name="mobile"
              label="手机号"
              placeholder="手机号"
              clearable
              :rules="[{ required: false, validator: (value, rule) => {
                  if (value) {
                    let m = value.match(/^1[3456789]\d{9}$/); 
                    return m ? true : false;
                  }
                  return true
                },
                //pattern:/^1[3456789]\d{9}$/, 
                message: '请填写正确的手机号' }]"
            />
          </van-cell-group>
          <div class="signup-btns">
            <van-button round block type="info" native-type="submit" :loading="saveLoading" loading-text="查询中...">
              开始查询
            </van-button>
          </div>
        </van-form>
        <van-cell-group title="绑定说明">
          <div style="padding:1rem; color:#777;">
            <p>* 仅支持查询【未绑定过微信】的学员信息。</p>
            <p>* 已绑定信息如需变更绑定请联系教务老师提供【微信绑定二维码】。</p>
          </div>
        </van-cell-group>
      </div>
    </div>
    <!-- 绑定选择 -->
    <van-dialog
      title="请选择要绑定学生"
      v-model="showStu"
      :show-confirm-button="false"
      show-cancel-button
      @cancel="cancelStu"
    >
      <van-cell-group>
        <van-cell v-for="item in stuList" :key="item.id" @click="itemClick(item)">
          <template>
            <div>
              <p style="display:flex; justify-content:space-between; align-items:center;">{{ item.name }} / {{ item.sexname }} <van-tag type="danger">{{ item._rolls.length }}学籍</van-tag></p>
              <p>身份证：{{ item.sfzh }}</p>
              <p>手机号：{{ item.mobile }}</p>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import siteMixin from '@/utils/site-mixin';
import { deepCopy } from '@/utils/utils';
export default {
  components: {
  },
  mixins: [siteMixin],
  props: {
    id: String,
    code: String
  },
  data() {
    return {
      stuLoading: false,
      showStu: false,
      error: false,
      isLoading: false,
      showXj: false,
      showCc: false,
      showYx: false,
      showZy: false,
      stuList: {},
      form: {},
      saveLoading: false
    }
  },
  computed: {
    ...mapGetters({
    }),
    defaultData() {
      return {
        id: null,
        sfzh: null,
        mobile: null,
      }
    },
    total() {
      return 0;
    }
  },
  watch: {
    id() {
      this.loadData();
    }
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });

    this.loadData();
  },
  created () {
    this.loadData();
  },
  mounted () {
    this.checkLogin();
  },
  methods: {
    loadData() {
      this.form = Object.assign({}, this.defaultData, {id: this.id});
      this.showStu = false;
      if (this.id) {
        this.loadStu();
      }
    },
    loadStu() {
      if (this.stuLoading) {
        return;
      }
      this.stuLoading = true;
      this.showStu = false;
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      this.doPost({
        url: 'site/bind/search',
        data: {id: this.id, code: this.code},
        okcb: (json) => {
          let list = json || [];
          list.map(d => {
            d._rolls = d._rolls ? JSON.parse(d._rolls) : [];
          });
          this.stuList = list;
          if (this.stuList.length) {
            this.showStu = true;
          } else {
            setTimeout(() => {
              this.Toast.fail('未查询到要绑定的学籍信息！');
            }, 50);
          }
        },
        cb: () => {
          this.$nextTick(() => {
            this.stuLoading = false;
            this.Toast.clear();
          });
        }
      });
    },
    cancelStu() {
      this.$router.push('/');
    },
    onSubmit(values) {
      let postData = deepCopy(this.form);
      if (!postData.sfzh && !postData.mobile) {
        this.Toast.fail('身份证号或手机号至少需要填写一项！');
        return;
      }
      if (postData.sfzh) {
        postData.sfzh = postData.sfzh.toUpperCase();
      }
      postData.id = null;

      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });

      this.saveLoading = true;
      this.doPost({
        url: 'site/bind/search',
        data: postData,
        okcb: (json) => {
          let list = json || [];
          list.map(d => {
            d._rolls = d._rolls ? JSON.parse(d._rolls) : [];
          });
          this.stuList = list;
          if (this.stuList.length) {
            this.showStu = true;
          } else {
            setTimeout(() => {
              this.Toast.fail('未查询到要绑定的学籍信息！');
            }, 50);
          }
        },
        cb: () => {
          this.saveLoading = false;
          this.Toast.clear();
        },
        errcb: (json) => {
          if (json && json.message) {
            setTimeout(() => {
              this.Toast.fail(json.message);
            }, 50);
          }
        }
      });
    },
    onFailed({ errors }) {
      if (errors.length) {
        this.$refs.form.scrollToField(errors[0].name);
      }
    },
    itemClick(data) {
      this.Dialog.confirm({
        message: '确定要绑定【'+ data.name +'】吗？',
      })
        .then(() => {
          // on confirm
          this.doBind(data.id);
        })
        .catch(() => {
          // on cancel
        });
    },
    doBind(id) {
      this.Toast.loading({
        message: '绑定中...',
        forbidClick: true
      });
      this.doPost({
        url: 'site/bind/'+ id,
        okcb: () => {
          setTimeout(() => {
            this.triggerWeb();

            this.Toast.success('绑定成功！');
            this.$router.push('/');
          }, 10);
        },
        cb: () => {
          this.Toast.clear();
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  /deep/ .van-field--error .van-field__control::placeholder {
    color: #ccc;
  }
}
.item-info {
  h4 {
    margin-bottom:.25rem;
    padding:0 .5rem;
    color:#888;
  }
  .detail {
    padding:.5rem .8rem;
    background-color:#fff;
  }
  .tit {
    .fontsize(1.2rem);
  }
  .con {
    margin-top:.25rem;
    color:#888;
  }
}
.form-info {
  padding-bottom:5.2rem;
  h4 {
    padding:0 .5rem;
    margin-bottom:.25rem;
    color:#888;
  }
  /deep/ .course-field {
    .van-checkbox-group,
    .van-checkbox__label {
      width:100%;
    }
  }
  /deep/ .course-item {
    .flex();
    padding:.35rem 0;
    .prices {
      margin-left: auto;
    }
    .market {
      display: inline-block;
      margin-right:.25rem;
      padding:0 .25rem;
      text-decoration: line-through;
      color:#aaa;
      small {
        .fontsize(.8rem);
      }
    }
    .price {
      display: inline-block;
      color: #ff6600;
      .fontsize(1.4rem);
      small {
        .fontsize(.85rem);
      }
    }
  }
}
.signup-btns {
  position:fixed;
  left:50%;
  bottom: 1rem;
  right: auto;
  width: 100%;
  max-width: 750px;
  transform: translateX(-50%);
  .flex-center-v();
  /deep/ .van-button--normal {
    .fontsize(1.2rem);
  }
  .prices {
    margin-right:2rem;
    padding:.5rem 1rem;
    white-space: nowrap;
    flex-shrink: 0;
    background-color:#f0f0f0;
    border-radius:2rem;
    .price {
      display: inline-block;
      color: #ff6600;
      .fontsize(1.2rem);
      small {
        .fontsize(.85rem);
      }
    }
  }
}
</style>